import posthog from 'posthog-js';

import { POSTHOG_HOST, POSTHOG_KEY } from '@/constants/env';

import type { PostHog } from 'posthog-js';

let posthogInstance: PostHog | null = null;

export const initializePostHog = (options?: Record<string, any>): PostHog | null => {
  if (!POSTHOG_KEY || !POSTHOG_HOST) {
    return null;
  }

  posthogInstance ??= posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true
      }
    },
    ...options
  });

  return posthogInstance;
};

export const getPostHog = (): PostHog | null => {
  return posthogInstance;
};
